const students = {

  edit: {
    tabs: {
      information: 'מידע',
      notes: 'הערות',
      parents: 'הורים',
      caregivers: 'מטפלים',
      history: 'היסטוריה',
      bookingHistory: 'היסטוריית הזמנות'
    },
  },
  table: {
    headers: {
      createBtn: 'הוסף',
      name: 'שם',
      email: 'אימייל',
      phone: 'טלפון',
      homeAddress: 'כתובת בית',
      alternateAddress: 'כתובת חלופית',
      schoolAddress: 'בית ספר',
      createdAt: 'נוצר בתאריך',
    },
  },
  form: {
    header: {
      create: {
        title: 'הוסף',
      },

      update: {
        title: 'עדכן',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'שמור',
        update: 'שמור',
      },
    },

    actions: {
      header: 'פעולות',
      buttons: {
        resetPassword: 'איפוס סיסמה',
      },
    },

    create: {
      confirmButtonText: 'שמור',
      toasts: {
        success: 'הורה נוצר בהצלחה',
        error: 'אירעה שגיאה בעת יצירת ההורה',
      },
    },
    update: {
      formTabs: {
        informationTab: 'מידע',
        notesTab: 'הערות',
      },

      activeStatus: {
        statusActive: 'פעיל',
        statusDeactivate: 'לא פעיל',
      },

      suspend: {
        actionActivate: 'בטל השעיה',
        actionDeactivate: 'השעיה',
        suspendModal: {
          popupTitleDeactivation: 'השעיית נוסע',
          popupTitleActive: 'סיבת השעיה',
          popupTitleUnsuspend: 'סיבת ביטול השעיה',
          popupSubTitleDeactivation: 'בחר את סיבת ההשעיה',
          popupActionActive: 'בטל השעיית נוסע',
          popupActionDeactivate: 'השעיית נוסע',
        },
      },
      toasts: {
        success: 'הורה עודכן בהצלחה',
        error: 'אירעה שגיאה בעת עדכון ההורה',
        fetchError: 'משהו השתבש\nאנא נסה שוב.',
      },
    },
    sections: {
      profiles: {
        fields: {
          label: 'פרופילים'
        }
      },
      attributes: {
        fields: {
          label: 'פרופילים'
        }
      },
      personalDetails: {
        header: 'פרטים אישיים',
        fields: {
          firstName: {
            label: 'שם פרטי',
          },
          lastName: {
            label: 'שם משפחה',
          },
          email: {
            label: 'אימייל',
          },
          phone: {
            label: 'טלפון',
          },
          additionalPhone: {
            label: 'טלפון נוסף',
          },
          gender: {
            label: 'מין',
          },
          dateBirth: {
            label: 'תאריך לידה',
          },
        },
      },
      schoolDetails: {
        header: 'פרטי בית ספר',
        fields: {
          school: {
            label: 'בית ספר',
          },
          academicYear: {
            label: 'שנת לימודים',
            options: {
              default: 'ברירת מחדל',
              current: '2023-2024',
            },
          },
          level: {
            label: 'רמה',
          },
          class: {
            label: 'כיתה',
          },
        },
      },
      profile: {
        header: 'פרופילים',
        fields: {
          profile: 'פרופילים',
        },
      },

      addresses: {
        header: 'כתובות תלמיד',
        fields: {
          mainAddress: {
            label: 'כתובת ראשית',
          },
          alternateAddress: {
            label: 'כתובת חלופית',
          },
          level: {
            label: 'רמה',
          },
          class: {
            label: 'כיתה',
          },
        },
      },
      linkParents: {
        header: 'הורים',
        add: 'הוסף',
        entity: 'הורים',

        parentsTable: {
          headers: {
            name: 'שם',
            address: 'כתובת',
            phone: 'טלפון',
            email: 'אימייל',
          },
        },
      },

      linkCaregivers: {
        header: 'מטפלים',
        add: 'הוסף',
        entity: 'מטפלים',

        caregiversTable: {
          headers: {
            name: 'שם',
            address: 'כתובת',
            phone: 'טלפון',
            email: 'אימייל',
          },
        },
      },
    },
  },
};

export default students;
